import { faFolder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React from "react";
import { assetTypes, contentDefinitionId } from "./NomadSelect";

export default class NomadFolderList extends React.Component {
  constructor(props) {
    super(props);

    this.state = { folders: [], loading: false };
  }

  componentDidMount() {
    this.refreshFolderList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.folderId !== prevProps.folderId) {
      this.refreshFolderList();
    }
  }

  async refreshFolderList() {
    if (!this.props.folderId) return;

    this.setState({ loading: true, folders: [] });
    await this.getFolderPage(0);
  }

  async getFolderPage(pageOffset) {
    const response = await axios.post(
      //"https://app-api.nomad.mainroads.wa.gov.au/api/portal/search",
      `${this.props.nomadApiUrl}/api/portal/search`,
      {
        filters: [
          {
            fieldName: "contentDefinitionId",
            operator: "Equals",
            values: contentDefinitionId,
          },
          {
            fieldName: "assetType",
            operator: "Equals",
            values: assetTypes.folder,
          },
          {
            fieldName: "parentId",
            operator: "Equals",
            values: this.props.folderId,
          },
        ],
        pageOffset,
        pageSize: 50,
      },
      {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
        },
      }
    );

    const folderInfo = response && response.data;
    if (folderInfo) {
      this.setState(
        { folders: [...this.state.folders, ...folderInfo.items] },
        () => {
          if (folderInfo.totalItemCount > this.state.folders.length)
            this.getFolderPage(pageOffset + 1);
          else this.setState({ loading: false });
        }
      );
    } else this.setState({ loading: false });
  }

  render() {
    return (
      (this.state.loading || this.state.folders.length > 0) && (
        <div className="nomad-folderList">
          {this.state.loading ? (
            <div>Loading...</div>
          ) : (
            this.state.folders.map((folder) => (
              <div
                key={folder.id}
                className="folderItem icon-left"
                data-id={folder.id}
                onClick={this.props.navigateToFolder}
              >
                <FontAwesomeIcon icon={faFolder} size="lg" />
                {folder.title}
              </div>
            ))
          )}
        </div>
      )
    );
  }
}
